import React from "react";
import styles from "./Admin.module.css";
import { CircleGo } from "../TableIcons/TableIcons";

const ConfirmEmployee = (props) => {
  const { showEmpMenu } = props;

  return (
    <>
      <div className={styles.confirm_button}>
        <button
          className={styles.button_without_bg}
          type="button"
          name="confirm employee"
          aria-label="confirm employee"
          onClick={showEmpMenu}
        >
          <span>confirm employee</span>
          <CircleGo />
        </button>
      </div>
    </>
  );
};

export default ConfirmEmployee;
